import { Box, Container, Grid, Typography } from "@mui/material";
import AutoGraphIcon from "@mui/icons-material/AutoGraph";
import { motion } from "framer-motion";

const ServiceWhyChoose = ({ service }) => {
  return (
    <Box sx={styles.section}>
      <Container maxWidth="lg">
        <Grid container spacing={6} alignItems="center">
          {/* Left Graphic */}
          <Grid item size={{ xs: 12, md: 6 }}>
            <Box sx={styles.graphicBox}>
              {service.why.map((item, index) => {
                const Icon = service.whyIcons?.[index] || AutoGraphIcon;

                return (
                  <motion.div
                    key={index}
                    animate={{ scale: [1, 1.08, 1] }}
                    transition={{
                      duration: 3,
                      repeat: Infinity,
                      delay: (index + 1) * 0.3,
                    }}
                  >
                    <Box
                      sx={{
                        ...styles.orbitCard,
                        borderColor: service.accent,
                      }}
                    >
                      <Icon sx={{ color: service.accent }} />
                    </Box>
                  </motion.div>
                );
              })}
            </Box>
          </Grid>

          {/* Right Content */}
          <Grid item size={{ xs: 12, md: 6 }}>
            <Typography sx={styles.heading}>Why Choose Our Service?</Typography>

            {service.why.map((item, index) => (
              <Box sx={styles.point} key={index}>
                <Box sx={{ ...styles.number, background: service.accent }}>
                  {index + 1}
                </Box>
                <Typography>{item}</Typography>
              </Box>
            ))}
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default ServiceWhyChoose;

const styles = {
  section: {
    py: { xs: 7, md: 11 },
    background: "#fff",
  },

  heading: {
    fontSize: { xs: "30px", md: "42px" },
    fontWeight: 800,
    mb: 4,
    color: "#071525",
  },

  point: {
    display: "flex",
    alignItems: "center",
    gap: 2,
    mb: 2.5,
    fontSize: "17px",
    color: "#334155",
  },

  number: {
    minWidth: 38,
    height: 38,
    borderRadius: "50%",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  graphicBox: {
    minHeight: 360,
    borderRadius: "32px",
    background:
      "radial-gradient(circle at center, rgba(8,45,99,0.15), transparent 60%)",
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: 3,
    p: 4,
  },

  orbitCard: {
    height: 130,
    borderRadius: "28px",
    border: "1px solid",
    background: "rgba(255,255,255,0.85)",
    boxShadow: "0 20px 60px rgba(7,21,37,0.08)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    "& svg": {
      fontSize: 48,
    },
  },
};
